<script setup lang="ts">
import { useToastStore } from "@/stores/toasts"

const toasts = useToastStore()
</script>

<template>
  <div class="toast-region" aria-live="polite" :aria-label="$t('Notifications')">
    <button v-for="toast in toasts.items" :key="toast.id" class="toast" :class="`toast-${toast.tone}`"
      type="button" @click="toasts.remove(toast.id)">
      {{ toast.message }}
    </button>
  </div>
</template>
